module.exports = __webpack_public_path__ + "img/female_blurred_std_avatar.5a00c2b5.jpg";